/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkstatePerformanceV2Dto } from './workstatePerformanceV2Dto';
import { CombinationDto } from './combinationDto';
import { EmployeeIdDto } from './employeeIdDto';

export interface CombinationEmployeePerformanceV2Dto {
  combination?: CombinationDto;
  duration?: number;
  employee?: EmployeeIdDto;
  fuelConsumed?: number;
  ha?: number;
  idleDuration?: number;
  km?: number;
  workstatePerformances?: Array<WorkstatePerformanceV2Dto>;
}
